import React from "react";
import { View } from "react-native";

export default function DropShadow({ style, children }) {
  return <View style={style}>{children}</View>;
}
